export const SESSION_CHANGED_EVENT = 'prime:session-changed';

const sessionListeners = new Set();

export function subscribeToSessionChanges(listener) {
  sessionListeners.add(listener);
  return () => {
    sessionListeners.delete(listener);
  };
}

export function notifySessionChanged() {
  const refreshes = Array.from(sessionListeners, (listener) =>
    Promise.resolve().then(() => listener()),
  );

  if (typeof window !== 'undefined') {
    window.dispatchEvent(
      new CustomEvent(SESSION_CHANGED_EVENT, {
        detail: { source: 'session-events' },
      }),
    );
  }

  return Promise.allSettled(refreshes).then(() => undefined);
}
